export default __webpack_public_path__ + "static/media/io.db116877.png";